<div
    class="trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
    [class.component-dark-theme]="themeService.isDark()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <div
        class="trezo-card-header d-flex align-items-center justify-content-between"
    >
        <div class="trezo-card-title">
            <h5 class="mb-0">Recent Orders</h5>
        </div>
        <div class="trezo-card-subtitle">
            <a
                routerLink="/dashboard/orders"
                class="btn btn-sm btn-outline-primary"
                >View All</a
            >
        </div>
    </div>
    <div class="trezo-card-content" *ngIf="data$ | async as data">
        <app-table
            [datasource$]="data$"
            [columns]="columns"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [actionButtons]="actions"
            [sortable]="true"
            [usePagination]="false"
            [useFilter]="false"
            [queryParameters]="searchOptions"
            [resultLength]="totalRecords"
            [useStickyHeaders]="false"
            [allowRowSelection]="false"
            [allowDragDrop]="false"
            (eventHandler)="tableEvent($event)"
        >
        </app-table>
    </div>
</div>
